import { PERMISSIONS } from "../constants/permissions";

// Ordered to match sidebar menu (MenuList.jsx)
const DASHBOARD_ROUTE_ENTRIES = [
  { permission: PERMISSIONS.USERS_VIEW, path: "/dashboard/users" },
  { permission: PERMISSIONS.CONTENTS_VIEW, path: "/dashboard/gallery" },
  { permission: PERMISSIONS.COURSES_VIEW, path: "/dashboard/courses" },
  { permission: PERMISSIONS.PACKAGES_VIEW, path: "/dashboard/packages" },
  { permission: PERMISSIONS.QUESTIONS_VIEW, path: "/dashboard/questions" },
  { permission: PERMISSIONS.EXAMS_VIEW, path: "/dashboard/exams" },
  { permission: PERMISSIONS.EXAMBANKS_VIEW, path: "/dashboard/ExamBanks" },
  { permission: PERMISSIONS.ROLES_VIEW, path: "/dashboard/roles" },
  { permission: PERMISSIONS.LOGS_VIEW, path: "/dashboard/logs" },
  { permission: PERMISSIONS.BACKUPS_VIEW, path: "/dashboard/backups" },
];

export const getDefaultDashboardRoute = (permissions = []) => {
  const entry = DASHBOARD_ROUTE_ENTRIES.find(({ permission }) =>
    permissions.includes(permission)
  );

  return entry?.path ?? "/dashboard/unauthorized";
};
